import {Link as MuiLink} from '@material-ui/core';
import {BoxProps} from '@material-ui/core/Box/Box';
import {Alert} from '@material-ui/lab';
import {useLocalStorage} from '@rehooks/local-storage';
import {LocalStorageKeys} from 'common/types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useSelector} from 'react-redux';
import RouterLink from 'screens/common/RouterLink';
import {
  getProSubscription,
  Subscription,
  SubscriptionStatus,
} from 'store/subscription/reducer';

interface ProSubRenewalAlertPropx extends BoxProps {

}

export const ProSubRenewalAlert = ({
  className
}: ProSubRenewalAlertPropx) => {
  const subscription = useSelector(getProSubscription);
  const [isAlertClosed, setAlertClosed] =
    useLocalStorage<boolean>(LocalStorageKeys.ProSubRenewAlert, false);

  if (subscription === null || isAlertClosed) {
    return null;
  }
  const subsCloseToExpire = subscription.status === SubscriptionStatus.ACTIVE
    && (subscription.validToDays > 0 && subscription.validToDays <= 2);

  if (!subsCloseToExpire) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      className={className}
      onClose={() => setAlertClosed(true)}
    >
      {
        subscription.isCancelled
          ? <CancelledSubscriptionMessage subscription={subscription}/>
          : <ActiveSubscriptionMessage subscription={subscription}/>
      }
    </Alert>
  );
};

interface SubscriptionMessageProps {
  subscription: Subscription;
}

const CancelledSubscriptionMessage = ({subscription}: SubscriptionMessageProps) => {
  return (
    <div>
      <FormattedMessage
        id="alerts.pro_sub_renewal_alert_cancelled"
        values={{
          days: subscription.validToDays,
          featureName: (
            <span style={{fontWeight: 'bold'}}>Rieltor&nbsp;PRO</span>
          ),
        }}
      />&nbsp;
      <FormattedMessage
        id="alerts.pro_sub_renewal_alert_cancelled_description"
        values={{
          link: <MuiLink
            // @ts-ignore
            to="/profile/subscription"
            component={RouterLink}
            color="inherit"
          >
            <span style={{fontWeight: 'bold'}}>Поновіть</span>
          </MuiLink>,
        }}
      />
    </div>
  );
};

const ActiveSubscriptionMessage = ({subscription}: SubscriptionMessageProps) => {
  return (
    <div>
      <FormattedMessage
        id="alerts.pro_sub_renewal_alert"
        values={{
          days: subscription.validToDays,
          featureName: (
            <span style={{fontWeight: 'bold'}}>Rieltor&nbsp;PRO</span>
          ),
        }}
      />&nbsp;
      <FormattedMessage
        id="alerts.pro_sub_renewal_alert_description"
        values={{
          link: <MuiLink
            // @ts-ignore
            to="/payment"
            component={RouterLink}
            color="inherit"
          >
            <span style={{fontWeight: 'bold'}}>поповніть</span>
          </MuiLink>,
        }}
      />
    </div>
  );
};
